import React, {  } from 'react';
import useGlobal from '../../store';
import AvatarUploader from '../General/AvatarUploader';

const UserProfile = (props) => {

    const [user] = useGlobal(
        state => state.user
    );

    const [myarchive] = useGlobal(
        state => state.myarchive
    );

    const [ui, uiActions] = useGlobal(
        state => state.ui,
        actions => actions.uiActions
    );

    const buildAvatarUrl = (userData) => {
        if(userData.hasOwnProperty('avatarFile') && userData.avatarFile && (userData.avatarFile.indexOf('_avatar') > 0 || userData.avatarFile.length > 30)) {
	        return "https://weblight.imgix.net/avatars/"+userData.avatarFile + "?w=100&h=100&fit=facearea&faceindex=1&facepad=2";
	    }
	    if(userData.FBID && userData.FBID !== "0") {
	        return "https://graph.facebook.com/" + userData.FBID + "/picture?type=large";
	    }
	    if(userData.hasOwnProperty('avatarFile') && userData.avatarFile) {
	        return "https://weblight.imgix.net/avatars/"+userData.avatarFile;
	    }
	    return "";
    }

    const today=new Date();
    let cmas=new Date(today.getFullYear(), 11, 25);
    if (today.getMonth() === 11 && today.getDate()>25) {
        cmas.setFullYear(cmas.getFullYear()+1); 
    }  
    const one_day=1000*60*60*24;
    const daysUntilChristmas = Math.ceil((cmas.getTime()-today.getTime())/(one_day));

    const tabClick = (tabname,e) => {
        e.preventDefault();
        uiActions.setDashboardActiveTab(tabname);
    }

    return (user ?
        <div className="kt-portlet kt-profile">
            <div className="kt-profile__content">
                <div className="row">
                    <div className="col-md-12 ">
                        <div className="kt-profile__main">
                            <div className="kt-profile__main-pic">
                                <AvatarUploader {...user} avatar={buildAvatarUrl(user)} ></AvatarUploader>
                            </div>
                            <div className="kt-profile__main-info">
                                <div className="kt-profile__main-info-name">{user.FirstName} {user.LastName}</div>
                                <div className="kt-profile__main-info-position">{daysUntilChristmas} days until Christmas!</div>
                            </div>
                        </div>
                        
                        
                    </div>
                    <div className="col-md-12 ">
                        {user.about ? <div className="mt-3 kt-profile__main-info-position">{user.about}</div> : <></> }
                    </div>
                    
                    
                </div>
            </div>
            <div className="kt-profile__nav">

                <ul className="nav nav-tabs nav-tabs-line" role="tablist">
                    <li className="nav-item hover-cursor">
                        <a href="#!" className={`nav-link ${ui.dashboard.activeTab === "home" ? "active" : ""}`} data-toggle="tab" onClick={(e) => tabClick("home", e)} role="tab">
                        <i className="flaticon-home-2"></i>Home</a>
                    </li>
                    <li className="nav-item hover-cursor">
                        <a href="#!" className={`nav-link ${ui.dashboard.activeTab === "mygiftlist" ? "active" : ""}`} data-toggle="tab" onClick={(e) => tabClick("mygiftlist", e)} role="tab">
                        <i className="flaticon2-gift-1"></i>Gift List</a>
                    </li>
                    <li className="nav-item hover-cursor">
                        <a href="#!" className={`nav-link ${ui.dashboard.activeTab === "myprofile" ? "active" : ""}`} data-toggle="tab" onClick={(e) => tabClick("myprofile", e)} role="tab">
                            <i className="flaticon2-calendar-3"></i>Profile</a>
                    </li>
                    {myarchive ? 
                    <li className="nav-item hover-cursor">
                        <a href="#!" className={`nav-link ${ui.dashboard.activeTab === "myarchive" ? "active" : ""}`} data-toggle="tab" onClick={(e) => tabClick("myarchive", e)} role="tab">
                            <i className="flaticon2-box-1"></i>Archive</a>
                    </li> : <></> }
                </ul>

            </div>
        </div>: <></>
        );
  
}

export default UserProfile;
